export var dataUrls = {
    loadBoston: 'http://scikitjs.org/data/boston.csv',
    loadIris: 'http://scikitjs.org/data/iris.csv',
    loadWine: 'http://scikitjs.org/data/wine.csv',
    loadDiabetes: 'http://scikitjs.org/data/diabetes.csv',
    loadBreastCancer: 'http://scikitjs.org/data/breast_cancer.csv',
    loadDigits: 'http://scikitjs.org/data/digits.csv',
    fetchCaliforniaHousing: 'http://scikitjs.org/data/california_housing.csv'
};
